import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { openExternalURL } from '@common/helpers/externalConnection';

/**
 * List of regex patterns for paths where history.push is allowed.
 * The rest should be using window.location.href to ensure a full page reload.
 * This is important for je-next transition.
 */
export function canUseHistoryPush(location: string): Boolean {
  return [
    /^\/\w{2}\/sign-up(?!\/business|\/job-title-business-selection|\/basic-details)\/?.*/i,
    /^\/\w{2}\/auth/,
    /^\/\w{2}\/forgot-password/,
    /^\/\w{2}\/forgot-password-success/,
    /^\/\w{2}\/reset-password/,
    /^\/\w{2}\/reset-password-success/,
    /^\/\w{2}\/account/,
    /^\/\w{2}\/region-selection/,
    /^\/\w{2}\/redirect/,
    /^\/\w{2}\/unsubscribe/
  ].some((pattern) => pattern.test(location));
}

export function useRedirect() {
  const history = useHistory();

  const redirect = useCallback(
    (location) => {
      const isExternal = /^https?:/.test(location);

      if (isExternal) {
        return () => openExternalURL(location);
      }

      if (canUseHistoryPush(location)) {
        return () => history.push(location);
      }

      return () => (window.location.href = location);
    },
    [history]
  );

  return { redirect };
}
